import Vue from "vue";
import axios from "axios";
import commonService from "./common";

// let baseURL = `${process.env.VUE_APP_CONFIG_RF_BASEURL}`;

let config = {
  method: "get",
  url: '',
  headers: {
    "x-api-key": `${process.env.VUE_APP_CONFIG_RF_APIKEY}`,
  },
  // data: data,
};

const axiosClient = axios.create(config);

const rfDashboardService = {


  getRfQuery(data) {
    let { index, from_dt, to_dt, from_msisdn, to_msisdn, cause_code, result_type, series, interval } = data;
    if (from_msisdn === "") {
      from_msisdn = 1;
    }
    if (to_msisdn === "") {
      to_msisdn = 1;
    }
    let param = `GetRfQuery&index=${index}&from_dt=${from_dt}&to_dt=${to_dt}&from_msisdn=${from_msisdn}&to_msisdn=${to_msisdn}&cause_code=${cause_code}&result_type=${result_type}`;
    if (series && interval) {
      param = `GetRfQuery&index=${index}&from_dt=${from_dt}&to_dt=${to_dt}&result_type=${result_type}&series=${series}&interval=${interval}`
    }
    config.url = `${process.env.VUE_APP_CONFIG_BASEURL}?method=${param}`;
    // return commonService.commonAPI(param)
    //   .then(response => response.data.message)
    //   .catch(error => console.error(error))
    return new Promise((resolve, reject) => {
      axiosClient
        .request(config)
        .then((response) => {
          if (!response.data) {
            reject(response);
          } else if (response.data.message.hasOwnProperty("hits")) {
            resolve(response.data.message);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getRfLocations(data) {
    let { index, from_dt, to_dt, from_msisdn, to_msisdn, result_type, series, interval } = data;
    let param = `GetRfQuery&index=${index}&from_dt=${from_dt}&to_dt=${to_dt}&from_msisdn=${from_msisdn}&to_msisdn=${to_msisdn}&result_type=${result_type}&series=${series}&interval=${interval}`
    config.headers['x-api-key'] = `${process.env.VUE_APP_CONFIG_APIKEY}`;
    config.url = `${process.env.VUE_APP_CONFIG_BASEURL}?method=${param}`;
    return axiosClient.request(config)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getUtranLocationInfo(utranCellId) {
    let param = `GetUtranLocationInfo&utran_cell_id=${utranCellId}`;
    config.method = "post";
    config.headers['x-api-key'] = `${process.env.VUE_APP_CONFIG_APIKEY}`;
    config.url = `${process.env.VUE_APP_CONFIG_BASEURL}?method=${param}`;
    return new Promise((resolve, reject) => {
      axiosClient
        .request(config)
        .then((response) => {
          // console.log(response.data.message);
          if (typeof response.data.message === "object") {
            resolve(response.data.message);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

};

export default rfDashboardService;
